import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

import Home from "./component/TourPackages/HomePage/Home";
import Lists from "./component/TourPackages/ListPage/Lists";
import Detail from "./component/TourPackages/Detailpage/Detail";
import FooterSection from "./component/TourPackages/Footer/FooterSection";
import NavbarMain from "./component/TourPackages/Navbar/NavbarMain";
import FooterClimax from "./component/TourPackages/Footer/FooterClimax";
import AboutUs from './component/TourPackages/AboutUs/AboutUs';
import PrivacyPolicy from './component/TourPackages/PrivacyPolicy/PrivacyPolicy';
import TermCondition from './component/TourPackages/TermsConditions/TermCondition';
import ContactUs from './component/TourPackages/ContactUs/ContactUs';
import Faqs from './component/TourPackages/FAQs/Faqs';
import TravelTips from './component/TourPackages/TravelTips/TravelTips';
import Testimonial from './component/TourPackages/Testimonial/Testimonial';
import CSR from './component/TourPackages/MoreLinks/CSR';
import Disclaimer from './component/TourPackages/MoreLinks/Disclaimer';
import JobCareer from './component/TourPackages/MoreLinks/JobCareer';
import OtherBusinesses from './component/TourPackages/MoreLinks/OtherBusinesses';
import MiceTravel from './component/TourPackages/MiceTravel/MiceTravel';
import Certificate from './component/TourPackages/MoreLinks/Certificate';
import InternationalPackages from './component/TourPackages/HomePage/InternationalPackages';
import PopularTourSection from './component/TourPackages/HomePage/PopularTourSection';
import GSTRegistration from './component/TourPackages/MoreLinks/GSTRegistration';
import ItineraryPage from './component/TourPackages/Detailpage/ItineraryPage';
import Blog from './component/TourPackages/Blog/Blog';
import BankDetails from './component/TourPackages/BankDetails/BankDetails';
import MiceGallery from './component/TourPackages/MiceTravel/MiceGallery';


// ✅ ScrollToTop component defined here
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top on route change
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div>
      <ScrollToTop /> {/* Automatically scrolls up on each route change */}
      <NavbarMain />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:pack" element={<Lists />} />
        <Route path="/:pack/:fullDetails" element={<Detail />} />
        <Route path="/about-plenary-holidays" element={<AboutUs />} />
        <Route path="/international-tour-packages" element={<InternationalPackages heading="Most Popular International Tours"/>} />
        <Route path="/india-holiday-packages" element={<PopularTourSection heading="Most Popular Indian Tours"/>} />
        <Route path="/mice-corporate-travel" element={<MiceTravel />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/plenaryholidays-certificates" element={<Certificate />} />
        <Route path="/csr" element={<CSR />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/job-career" element={<JobCareer />} />
        <Route path="/travel-tips" element={<TravelTips />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermCondition />} />
        <Route path="/other-businesses" element={<OtherBusinesses />} />
        <Route path="/gst-registration" element={<GSTRegistration />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/itinerary" element={<ItineraryPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/payment" element={<BankDetails />} />
        <Route path="/mice-gallery" element={<MiceGallery />} />
      </Routes>
      <FooterSection />
      <FooterClimax />
    </div>
  );
}

export default App;
